






// Composition
import { computed, defineComponent, useRouter } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

// Store
import { useSearchStore } from '@/store/search'

// Composable
import useSearchUrl from '@/composables/search/useSearchUrl'

// Components
import Pagination from '@/components/feature/search/nav/Pagination.vue'
import { QueryStyle } from '~/types/search/searchTypes'

export default defineComponent({
  components: {
    Pagination,
  },
  setup() {
    const searchStore = useSearchStore()
    const { getResults, page } = storeToRefs(searchStore)
    const { getSearchUrl } = useSearchUrl()
    const router = useRouter()
    const currentPage = computed(() => page.value.currentPage)

    const numbersArray = computed(() => {
      // vars
      const totalPages =
        getResults.value.meta?.page?.total_pages !== undefined ? getResults.value.meta.page.total_pages : 1
      const nrArray: Array<number> = [page.value.currentPage]

      // Add numbers before
      if (page.value.currentPage === 2) {
        nrArray.unshift(1)
      } else if (page.value.currentPage > 2) {
        nrArray.unshift(page.value.currentPage - 2, page.value.currentPage - 1)
      }

      // add numbers after
      if (page.value.currentPage < totalPages) {
        // add one directly after currentPage
        nrArray.push(page.value.currentPage + 1)

        // check for second
        if (page.value.currentPage + 2 <= totalPages) {
          nrArray.push(page.value.currentPage + 2)
        }
      }

      return nrArray
    })

    const changePagination = (nr: number) => {
      searchStore.setQueryStyle(QueryStyle.UI)

      // set in store
      searchStore.setCurrentPage(nr)

      // perform query
      router.push(getSearchUrl({ nr }))
    }

    return {
      page,
      getResults,
      currentPage,
      numbersArray,
      changePagination,
    }
  }, // end setup
})
